import React from "react"
import type { ReducedSpotifyPlaylistType } from "types/blog-v2-types"

type Props = {
  href: ReducedSpotifyPlaylistType["href"]
  reference: ReducedSpotifyPlaylistType["reference"]
  compact?: ReducedSpotifyPlaylistType["compact"]
  caption?: ReducedSpotifyPlaylistType["caption"]
}

import { containerVariants, cap } from "./SpotifyPlaylist.css"

export const SpotifyPlaylist: React.FC<Props> = ({
  href,
  reference,
  compact,
  caption,
}) => (
  <div
    className={compact ? containerVariants.Compact : containerVariants.Default}
  >
    <iframe
      style={{ borderRadius: "12px" }}
      src={href}
      width="100%"
      height="100%"
      frameBorder="0"
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
      title={reference}
    />
    {caption && <span className={cap}>{caption}</span>}
  </div>
)
